var _g, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUploadCheque(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2962_5590)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 33C28.0751 33 33 28.0751 33 22C33 15.9249 28.0751 11 22 11C15.9249 11 11 15.9249 11 22C11 28.0751 15.9249 33 22 33Z",
    fill: "#667080"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8876 22.5797L21.888 22.5794L21.8881 22.5793L21.8882 22.5794L21.8881 22.5795L21.8876 22.5797ZM21.9015 22.5672L25.0172 19.5038L25.4829 20.079L22.3206 23.1882L22.3171 23.1896L22.3079 23.1945L21.2076 23.7795C21.208 23.7785 21.2084 23.7779 21.2086 23.7775L21.2128 23.7712L21.2166 23.7646L21.8887 22.5798L21.8897 22.578L21.8948 22.5738L21.9015 22.5672ZM27.7908 17.7878L27.7929 17.7905C27.7937 17.7927 27.7944 17.796 27.7942 17.8004C27.7938 17.8065 27.792 17.8094 27.7916 17.8101L27.7851 17.8154L27.7789 17.8216L25.9671 19.603L25.5015 19.0277L27.3389 17.2211L27.7908 17.7878Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.411586
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8562 20.1925V20.3956V20.8731V21.0762H27.6531H25.9657L24.8699 22.135H27.3516H27.5547V22.3381V22.8156V23.0187H27.3516H23.9554L23.5332 23.4266L23.5338 23.4272L23.3986 23.5579L23.1791 23.7699L23.1791 23.77L23.038 23.6239C22.9955 23.6649 22.9518 23.6916 22.9013 23.718L27.8562 20.1925ZM27.8562 20.1925H27.6531H26.8803M27.8562 20.1925H26.8803M22.9953 23.898L22.1227 24.3539L22.1231 24.3548L21.9546 24.4429L21.6912 24.5805L21.6912 24.5805L21.5972 24.4005C21.3431 24.5332 21.038 24.4158 20.9164 24.1386C20.8372 23.9581 20.8581 23.7528 20.9544 23.586L22.9953 23.898ZM22.9953 23.898C22.9953 23.898 22.9953 23.898 22.9954 23.898L22.9953 23.898ZM26.8803 20.1925L27.1942 19.8892L27.0531 19.7431L27.1942 19.8892L27.9042 19.2031H28.7083C28.7409 19.2031 28.7969 19.2376 28.7969 19.3183V25.2405C28.7969 25.3212 28.7409 25.3557 28.7083 25.3557H15.2917C15.2591 25.3557 15.2031 25.3212 15.2031 25.2405V19.3183C15.2031 19.2376 15.2591 19.2031 15.2917 19.2031H24.5537L21.7968 21.867L21.7967 21.8668L21.7898 21.8741C21.7715 21.8936 21.754 21.9118 21.7371 21.9294C21.6751 21.9939 21.6204 22.0507 21.562 22.135H16.3051H16.1019V22.3381V22.8156V23.0187H16.3051H21.0473L26.8803 20.1925ZM18.7436 21.039V20.8731V20.3956V20.1925H18.5405H16.3051H16.102V20.3956V20.8731V21.039H16.1019V21.2421V21.7195V21.9227H16.3051H21.0201H21.2233V21.7195V21.2421V21.039H21.0201H18.7436ZM25.4177 23.8116H25.2146V24.0147V24.4922V24.6953H25.4177H27.6531H27.8562V24.4922V24.0147V23.8116H27.6531H25.4177ZM16.3051 23.8116H16.102V24.0147V24.4922V24.6953H16.3051H18.5405H18.7436V24.4922V24.0147V23.8116H18.5405H16.3051Z",
    fill: "#FFFFFE",
    stroke: "white",
    strokeWidth: 0.40625
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2962_5590",
    x: 0,
    y: 0,
    width: 46,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.490196 0 0 0 0 0.6 0 0 0 0 0.705882 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2962_5590"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2962_5590",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCheque);
export default __webpack_public_path__ + "static/media/upload-cheque.7d004101db068b9b21007ec6891f6e7f.svg";
export { ForwardRef as ReactComponent };